import {Option} from "ts-option";

export default class WarrantyInfoData {
	/**
	 * Warranty info data object
	 * @param {Option<string>} merchantId
	 * @param {Option<string>} title
	 * @param {Option<string>} boiler serial number
	 * @param {Option<string>} cylinder serial number
	 * @param {Option<string>} filter serial number
	 * @param {Option<string>} control serial number
	 */
	constructor(
		public readonly merchantId: Option<string>,
		public readonly title: Option<string>,
		public readonly boiler: Option<string>,
		public readonly cylinder: Option<string>,
		public readonly filter: Option<string>,
		public readonly control: Option<string>) {}
}